import { RootState } from 'modules/store';

const root = (state: RootState) => state.app;

export const getCurrentEnvironment = (state: RootState) => root(state).currentEnvironment;
